/*
 * @Author: withease-partner+cao@hashdash-group.com
 * @Description: the frame page of 「成功的按钮：边角是圆的有背景颜色的按钮」
 */
<template>
  <div class="backnextbutton-container">
    <div class="container-by">
      <cRoundButton
        class="btn-list"
        :disabled="disabled"
        text="次へ"
        @clickbtn="goNext"
      ></cRoundButton>
    </div>

  </div>
</template>


<script>
export default {
  props: ['disabled'],
  methods: {
    goNext() {
      if (!this.disabled) {
        this.$emit('clickNext');
      }
    },
  }
};
</script>

<style lang="less" scoped>
.backnextbutton-container {
  width: 100%;
  height: 1rem;
  background: #ffffff;
  //padding: 0 0.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  .container-by{
    width: 100%;
    max-width: 6.8rem;
    height: 1rem;
    background: #ffffff;
    //padding: 0 0.3rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn-list {
    width: 100%;
  }
}
@media screen and (max-width:750px){
  .backnextbutton-container{
    padding: 0 0.2rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Button/cNextButton.vue